import Splide from "@splidejs/splide";
import GLightbox from "glightbox";
import ModelViewerElement from "@google/model-viewer";

document.addEventListener("DOMContentLoaded", function (event) {

    const button = document.querySelector('[data-behaviour="menubutton"]');
    if(button) {
        button.addEventListener("click", () => {
            document.body.classList.toggle('body--shownav');
        });
    };

    // Gallery popup

    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // Overlay popup (pages)

    const lightbox2 = GLightbox({
        selector: '[data-behaviour="overlay"]',
        skin: 'overlay',
        touchNavigation: true,
        loop: true,
        height: '100vh',
        openEffect: 'fade',
    });

    const pdfLightbox = GLightbox({
        elements: [
            {
                'href': 'images/stormarnschule_2023.pdf',
                // 'type': 'iframe',
                'width': '90vw',
                'height': '90vh',
            }
        ]
    });

    const lightboxButton = document.querySelector('[data-behaviour="pdf-lightbox"]');
    if(lightboxButton) {
        lightboxButton.addEventListener("click", (event) => {
            if (window.innerWidth > 768) {
                event.preventDefault();
                pdfLightbox.open();
            }
        });
    }

    // Slideshow

    const slides = [...document.querySelectorAll('[data-behaviour="slider"]')];
    slides.forEach(slideshow => {
        new Splide( slideshow, {
            // type: 'fade',
            rewind: true,
            drag: true,
            autoHeight: true,
            // width: '100%',
            // height: '100%',
            // autoplay: true,

            // interval: 4000,
            speed: 500,
            // arrows: false,
            breakpoints: {
                600: {
                    arrows: false,
                }
            }
        }).mount();
    })

    const headerSlider = [...document.querySelectorAll('[data-behaviour="headerslider"]')];
    headerSlider.forEach(slideshow => {
        new Splide( slideshow, {
            // type: 'fade',
            rewind: true,
            drag: true,
            // autoHeight: true,
            // width: '100%',
            // height: '100%',
            autoplay: true,
            perPage: 3,

            // interval: 4000,
            speed: 500,
            arrows: false,
            breakpoints: {
                1200: {
                    perPage: 2,
                }
            }
        }).mount();
    })

    //FormerStudentsPage
    let yearButtons = document.querySelectorAll('[data-behaviour="formerstudents-year-button"]');
    var currentYear = new Date().getFullYear() - 1;
    var maxYear = 0;
    var minYear = 9999;

    const formerstudents_next = document.querySelector('[data-behaviour="formerstudents-next-button"]');
    const formerstudents_previous = document.querySelector('[data-behaviour="formerstudents-previous-button"]');

    if(formerstudents_next){
        formerstudents_next.addEventListener("click", () => {
            currentYear -= 1;
            updateFormerYears();
        });
    }

    if(formerstudents_previous){
        formerstudents_previous.addEventListener("click", () => {
            currentYear += 1;
            updateFormerYears();
        });
    }

    var url_string = window.location.href;
    var url = new URL(url_string);
    var chosenYear = url.searchParams.get("year");
    
    if(chosenYear) {
        currentYear = chosenYear;
    }

    if(yearButtons) {
        yearButtons.forEach(item => {
            if(item.getAttribute('data-year') > maxYear){
                maxYear = item.getAttribute('data-year');
            }
            if(item.getAttribute('data-year') < minYear){
                minYear = item.getAttribute('data-year');
            }
            if(!chosenYear) {
                currentYear = maxYear;
            }

            item.addEventListener("click", (e) => {
                e.preventDefault;
                currentYear = parseInt(item.getAttribute('data-year'));
                updateFormerYears();
            });
        });
    };
    let yearDisplays = document.querySelectorAll('[data-behaviour="formerstudents-year-display"]');
    function updateFormerYears()
    {
        if(yearDisplays) {
            yearDisplays.forEach(item => {
                if(item.getAttribute('data-year') == currentYear){
                    item.classList.add("visible");
                } else {
                    item.classList.remove("visible");
                }
            });
        }

        if(yearButtons){
            yearButtons.forEach(item => {
                if(currentYear == item.getAttribute('data-year')){
                    item.classList.add("visible");
                    item.scrollIntoView({
                        behavior: 'smooth', block: 'nearest', inline: 'center' 
                    });
                } else {
                    item.classList.remove("visible");
                }
            });
        }

        if(formerstudents_previous){

            //Only set the url params if a previous button is present
            var url_string = window.location.href;
            var url = new URL(url_string);
            url.searchParams.set("year", currentYear);
            history.replaceState(null, null, url.toString());

            if(currentYear >= maxYear){
                formerstudents_previous.classList.add("hidden");
            } else {
                formerstudents_previous.classList.remove("hidden");
            }
        }

        if(formerstudents_next){
            if(currentYear <= minYear){
                formerstudents_next.classList.add("hidden");
            } else {
                formerstudents_next.classList.remove("hidden");
            }
        }
    }
    updateFormerYears();


    // Main menu
    const mainmenu = document.querySelector('[data-behaviour="mainmenu"]');

    if(mainmenu) {
        const mainItems = mainmenu.children;
        [...mainItems].forEach(item => {
            const mainLink = item.children[0];
            const hasChildren = !!item.querySelector('ul');
            if(hasChildren) {
                mainLink.addEventListener('click', event => {
                    event.preventDefault();
                    item.classList.toggle('mainmenu--open');
                })
            }
        });
    }

    //Show hide
    let showHideElements = [...document.querySelectorAll('[data-behaviour="showhide"]')];

    showHideElements.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            element.parentNode.classList.toggle("showhide--selected")

            showHideElements.filter(e => e != element).forEach((e) => e.parentNode.classList.remove("showhide--selected"));
            setTimeout(() => {
                // console.log(element.scrollTop);
                // window.scrollTo({
                //     top: element.parentNode.scrollTop,
                //     behavior: 'smooth',
                // });
                element.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 500);
        })
    });
});
